import type { ComponentProps } from 'react';

const AvatarSon = (props: ComponentProps<'svg'>) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M24 46C36.1503 46 46 36.1503 46 24C46 11.8497 36.1503 2 24 2C11.8497 2 2 11.8497 2 24C2 36.1503 11.8497 46 24 46Z"
      fill="#ECF7F6"
    />
    <mask
      id="mask0_208_42889"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="2"
      y="2"
      width="44"
      height="44"
    >
      <path
        d="M24 46C36.1503 46 46 36.1503 46 24C46 11.8497 36.1503 2 24 2C11.8497 2 2 11.8497 2 24C2 36.1503 11.8497 46 24 46Z"
        fill="#ECF7F6"
      />
    </mask>
    <g mask="url(#mask0_208_42889)">
      <path
        d="M25.1967 10.8623H21.7962C17.9047 10.8623 14.75 14.017 14.75 17.9086V27.1146C14.75 31.0062 17.9047 34.1609 21.7962 34.1609H25.1967C29.0882 34.1609 32.2429 31.0062 32.2429 27.1146V17.9086C32.2429 14.017 29.0882 10.8623 25.1967 10.8623Z"
        fill="#FFBF9F"
      />
      <path
        d="M32.2429 22.3978V17.913C32.2441 16.045 31.5035 14.253 30.1838 12.9308C28.8642 11.6087 27.0736 10.8647 25.2056 10.8623H21.8007C19.9307 10.8623 18.1374 11.6051 16.8151 12.9274C15.4928 14.2497 14.75 16.043 14.75 17.913V22.3978C16.0174 21.8517 17.1247 20.9916 17.9674 19.8988C19.4936 17.7033 19.0697 16.1994 19.0697 16.1994C19.2202 16.775 19.5198 17.3007 19.9381 17.7238C20.3564 18.1468 20.8788 18.4522 21.4526 18.6092C22.6218 18.8858 23.6571 18.2343 24.4782 17.3552C24.4427 17.749 24.4965 18.1457 24.6356 18.5158C24.7746 18.8858 24.9954 19.2198 25.2814 19.4927C25.5354 19.743 25.8389 19.9374 26.1724 20.0634C26.5059 20.1895 26.8622 20.2444 27.2182 20.2246C27.9336 20.1806 28.6281 19.9664 29.2441 19.5998C29.0897 19.7883 28.9831 20.0113 28.9334 20.2498C28.8837 20.4883 28.8923 20.7353 28.9585 20.9698C29.0907 21.4553 29.3774 21.8845 29.7752 22.1925C30.4936 22.7726 31.3504 22.6254 32.2429 22.3978Z"
        fill="#263F43"
      />
      <path
        d="M13.7138 27.387C15.1802 27.387 16.3689 26.1982 16.3689 24.7318C16.3689 23.2654 15.1802 22.0767 13.7138 22.0767C12.2474 22.0767 11.0586 23.2654 11.0586 24.7318C11.0586 26.1982 12.2474 27.387 13.7138 27.387Z"
        fill="#FFBF9F"
      />
      <path
        d="M33.2958 27.387C34.7622 27.387 35.951 26.1982 35.951 24.7318C35.951 23.2654 34.7622 22.0767 33.2958 22.0767C31.8294 22.0767 30.6406 23.2654 30.6406 24.7318C30.6406 26.1982 31.8294 27.387 33.2958 27.387Z"
        fill="#FFBF9F"
      />
      <path
        d="M28.243 25.2849C28.7137 25.2849 29.0953 24.6855 29.0953 23.9462C29.0953 23.2068 28.7137 22.6074 28.243 22.6074C27.7722 22.6074 27.3906 23.2068 27.3906 23.9462C27.3906 24.6855 27.7722 25.2849 28.243 25.2849Z"
        fill="#263F43"
      />
      <path
        d="M18.8641 25.2849C19.3348 25.2849 19.7164 24.6855 19.7164 23.9462C19.7164 23.2068 19.3348 22.6074 18.8641 22.6074C18.3933 22.6074 18.0117 23.2068 18.0117 23.9462C18.0117 24.6855 18.3933 25.2849 18.8641 25.2849Z"
        fill="#263F43"
      />
      <path
        d="M27.1425 26.6235L23.6172 28.9797C23.6172 28.9797 25.0318 30.9611 26.7989 29.7473C28.4902 28.587 27.1425 26.6235 27.1425 26.6235Z"
        fill="white"
      />
      <path
        d="M22.2942 28.0653C22.2407 28.0653 20.9912 27.4986 20.7547 26.3428C20.709 26.1866 20.7068 26.0209 20.7485 25.8636C20.7902 25.7063 20.8741 25.5634 20.9912 25.4503C21.1379 25.3429 21.305 25.2666 21.4822 25.2259C21.6595 25.1853 21.8431 25.1811 22.022 25.2138V22.2373H22.9145V25.7805C22.9178 25.8523 22.9038 25.9238 22.8735 25.989C22.8433 26.0542 22.7978 26.1111 22.7408 26.1549C22.6838 26.1987 22.6172 26.2281 22.5464 26.2407C22.4756 26.2532 22.4029 26.2484 22.3344 26.2268C22.105 26.1487 21.8614 26.1213 21.6204 26.1464C21.6192 26.1598 21.6192 26.1732 21.6204 26.1866C21.7587 26.8783 22.6289 27.2665 22.6378 27.271L22.2942 28.0653Z"
        fill="#263F43"
      />
      <path
        d="M14.4953 35.7495H33.4921C34.9144 35.7495 36.3227 36.0297 37.6367 36.5739C38.9507 37.1182 40.1446 37.916 41.1503 38.9217C42.156 39.9274 42.9538 41.1213 43.4981 42.4353C44.0424 43.7493 44.3225 45.1577 44.3225 46.5799V71.7394H3.67383L3.67383 46.5799C3.67383 43.7091 4.81366 40.9557 6.84283 38.9248C8.872 36.894 11.6245 35.7519 14.4953 35.7495Z"
        fill="#5BAFA9"
      />
      <path
        d="M31.6364 35.7495C30.1325 38.6769 27.2765 40.6582 24.0011 40.6582C20.7256 40.6582 17.8652 38.6769 16.3613 35.7495H31.6364Z"
        fill="#85CFC9"
      />
      <path
        d="M29.3927 35.7495C28.8537 36.7048 28.0705 37.4998 27.1233 38.0529C26.1761 38.6061 25.0989 38.8976 24.002 38.8976C22.9051 38.8976 21.8279 38.6061 20.8807 38.0529C19.9335 37.4998 19.1503 36.7048 18.6113 35.7495H29.3927Z"
        fill="#FFBF9F"
      />
    </g>
  </svg>
);

export default AvatarSon;
